export const selectTimeSubText = (isInstallationHardware: boolean, isTimeSelected: boolean): string => {
    const endDot = (isTimeSelected ? '' : '.');

    return isInstallationHardware
        ? `Привезёт и подключит оборудование, проложит кабель, проверит и покажет, как всё работает. Поможет оплатить услуги онлайн: на сайте или в мобильном приложении${endDot}`
        : `А ещё покажет, как все работает, ответит на вопросы и поможет оплатить услуги на сайте или в мобильном приложении${endDot}`;
};

export default selectTimeSubText;
